import { atom, selector } from "recoil"
export const surveyResponsesAtom = atom({
    key: "surveyResponsesAtom",
    default: {}
})

export const surveyIsFinishedAtom = atom({
    key: "surveyIsFinishedAtom",
    default: false
})

export const surveyProgressAtom = atom({
    key: "surveyProgressAtom",
    default: []
})

export const canGotoNextAtom = atom({
    key: "canGotoNextAtom",
    default: true
})
